// extracted by css-extract-rspack-plugin
export default {"SanitizedHtml":"use-labels-editor-module__SanitizedHtml__CqMdX","Box":"use-labels-editor-module__Box__Dcjvx"};